<div id="calendar-header" class="header landing-header">
  <img
    src="/assets/images/meetingscheduler-logo.png"
    class="logo"
    alt="Meeting Scheduler"
    i18n-alt="@@LOGO_ALT"
  />
</div>

<section class="intro-section alternate-bg">
  <div class="container container--wide">
    <div class="row">
      <div class="col col-md-6">
        <img
          src="/assets/images/meetingscheduler.png"
          alt="meeting scheduler calendar"
          i18n-alt="@@LANDING_PAGE.MEETING_SCHEDULER_CALENDAR_ALT"
        />
      </div>
      <div class="col col-md-6 text-col">
        <h1
          data-testid="title"
          i18n="@@LANDING_PAGE.HASSLE_FREE_MEETING_SCHEDULING"
        >
          Provide hassle-free appointment scheduling to your customers
        </h1>
        <p class="intro-text" i18n="@@LANDING_PAGE.SEAMLESSLY_CONNECTS">
          Integrates perfectly with all types of businesses
        </p>

        <p class="fine-print" i18n="@@LANDING_PAGE.CURRENTLY_IN_BETA">Book Me Now is currently in beta. Pre-register now to gain first access.</p>
        <div class="cta-button">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScC8aVzhxXzWEXBoP_l7kx3rA7ICfhzOTOMsHcFHp1TiGfuAw/viewform" class="button">
            <ng-container i18n="@@LANDING_PAGE.SECURE_MY_SPOT">Secure my spot!</ng-container>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="points-section">
  <div class="container container--wide">
    <div class="row">
      <div class="col col-md-4">
        <div class="points-icon">
          <mat-icon>check</mat-icon>
        </div>
        <h2 i18n="@@LANDING_PAGE.RETAIN_COMPLETE_CONTROL">
          Retain complete control over your availability
        </h2>
        <p i18n="@@LANDING_PAGE.SET_GENERAL_HOURS">
          Set your general hours and restrict specific times depending on your
          availability. Publicly displayed availability will stay in sync with
          your Google calendar in real time.
        </p>
      </div>
      <div class="col col-md-4">
        <div class="points-icon">
          <mat-icon>add</mat-icon>
        </div>
        <h2 i18n="@@LANDING_PAGE.PERSONALIZE_DOMAIN">
          Customize the booking experience to fit your unique needs
        </h2>
        <p i18n="@@LANDING_PAGE.RECEIVE_UNIQUE_LANDING_PAGE">
          Create a unique and personalized scheduler by customizing meeting times, submission forms, and URLs that help
          make the experience memorable and that develops brand recognition.
        </p>
      </div>
      <div class="col col-md-4">
        <div class="points-icon">
          <mat-icon>priority_high</mat-icon>
        </div>
        <h2 i18n="@@LANDING_PAGE.RECEIVE_EMAIL_ALERTS">
          Receive email alerts when meetings are booked
        </h2>
        <p i18n="@@LANDING_PAGE.NO_NEED_TO_LOGIN">
          There’s no need to login to check if a meeting has been scheduled.
          We’ll alert you via email, and automatically add the meeting to your
          Google Calendar.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="screenshot-section alternate-bg">
  <div class="container container--wide">
    <div class="row">
      <div class="col col-md-4">
        <p class="pre-head" i18n="@@LANDING_PAGE.HOW_DOES_IT_WORK">
          How does it work?
        </p>
        <h2 i18n="@@LANDING_PAGE.SHARE_PERSONALIZED_LINK">
          Just share your personalized link with anyone
        </h2>
        <p i18n="@@LANDING_PAGE.PROVIDE_ACCESS_TO_BOOKING_PAGE">
          Whether it’s a link in an email or a button on your website, providing
          access to you unique booking page is easy. Once visitors arrive,
          there’s a simple two-step process to book a meeting with you.
        </p>
      </div>
      <div class="col col-md-8">
        <img
          src="/assets/images/confirm-time.png"
          alt="confirm meeting time"
          i18n-alt="@@LANDING_PAGE.CONFIRM_MEETING_TIME_ALT"
        />
      </div>
    </div>
  </div>
</section>

<section class="footer-section">
  <div class="container container--wide">
    <p class="pre-head" i18n="@@LANDING_PAGE.DID_YOU_GET">
      Would you like to be one of the first businesses to use our new Meeting Scheduler?
    </p>
    <p class="fine-print" i18n="@@LANDING_PAGE.LET_THEM_KNOW">
      Sign up for our beta access and we’ll reach out once it’s available!
    </p>
    <div class="cta-button">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLScC8aVzhxXzWEXBoP_l7kx3rA7ICfhzOTOMsHcFHp1TiGfuAw/viewform" class="button">
        <ng-container i18n="@@LANDING_PAGE.SECURE_MY_SPOT">Secure my spot!</ng-container>
      </a>
    </div>
    <div>
      <a [routerLink]="['/terms/privacy-policy']" style="margin-right: 16px">Privacy policy</a>
      <a [routerLink]="['/terms/terms-of-service']">Terms of service</a>
    </div>
  </div>
</section>
